export enum ELanguageCodes {
    en = 'en',
    cs = 'cs',
    sk = 'sk',
    nb = 'nb'
}

export const languages: {
    title: string;
    code: ELanguageCodes;
    img: string;
}[] = [
    {
        title: 'English',
        code: ELanguageCodes.en,
        img: 'https://flagcdn.com/32x24/gb.png'
    },
    {
        title: 'Česky',
        code: ELanguageCodes.cs,
        img: 'https://flagcdn.com/32x24/cz.png'
    },
    {
        title: 'Norsk',
        code: ELanguageCodes.nb,
        img: 'https://flagcdn.com/32x24/no.png'
    },
    {
        title: 'Slovensky',
        code: ELanguageCodes.sk,
        img: 'https://flagcdn.com/32x24/sk.png'
    }
];
